
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/toolbar-button",
      function () {
        return require("private-next-pages/x/api/charts/toolbar-button.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/toolbar-button"])
      });
    }
  